import "@arco-design/web-react/es/Dropdown/style";
import _Dropdown from "@arco-design/web-react/es/Dropdown";
import _IconSunFill from "@arco-design/web-react/icon/react-icon/IconSunFill";
import _IconMoonFill from "@arco-design/web-react/icon/react-icon/IconMoonFill";
import "@arco-design/web-react/es/Menu/style";
import _Menu from "@arco-design/web-react/es/Menu";
import _IconPoweroff from "@arco-design/web-react/icon/react-icon/IconPoweroff";
import "@arco-design/web-react/es/Message/style";
import _Message from "@arco-design/web-react/es/Message";
import React, { useContext } from 'react';
import styles from './style/index.module.less';
import IconButton from '@/components/NavBar/IconButton';
import { GlobalContext } from '@/context';
function Navbar() {
  const user = JSON.parse(localStorage.getItem('user'));
  const {
    theme,
    setTheme
  } = useContext(GlobalContext);
  function logout() {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    window.location.href = '/login';
  }
  function onMenuItemClick(key) {
    if (key === 'logout') {
      logout();
    } else {
      _Message.info(`You clicked ${key}`);
    }
  }
  const droplist = /*#__PURE__*/React.createElement(_Menu, {
    onClickMenuItem: onMenuItemClick
  }, /*#__PURE__*/React.createElement(_Menu.Item, {
    key: "logout"
  }, /*#__PURE__*/React.createElement(_IconPoweroff, {
    className: styles['dropdown-icon']
  }), "\u9000\u51FA"));
  return /*#__PURE__*/React.createElement("div", {
    className: styles.navbar
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['logo-name']
  }, "\u7BA1\u7406\u540E\u53F0"))), /*#__PURE__*/React.createElement("ul", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(IconButton, {
    icon: theme !== 'dark' ? /*#__PURE__*/React.createElement(_IconMoonFill, null) : /*#__PURE__*/React.createElement(_IconSunFill, null),
    onClick: () => setTheme(theme === 'light' ? 'dark' : 'light')
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(_Dropdown, {
    droplist: droplist,
    position: "br"
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--color-text-1)',
      cursor: 'pointer'
    }
  }, user?.username)))));
}
export default Navbar;